import deviceApi from '@api/deviceApi';
import Title from '@components/title';
import { useTranslator } from '@i18n';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useHandleError } from '@util/errors';

export const Route = createFileRoute('/inventory/$deviceType/$deviceId')({
  component: DeviceWrapper,
});

function DeviceWrapper() {
  const t = useTranslator();
  const { deviceType, deviceId } = Route.useParams();

  const [device, deviceError] = deviceApi.getGlobal(deviceType, deviceId).useCache();
  useHandleError([deviceError]);

  return (
    <Title
      title={[
        t.dynamic(`entities.${deviceType}`, {}, { fallback: deviceType }),
        String(device?.location?.sequenceNumber || deviceId).padStart(4, '0'),
      ].join(' ')}
    >
      <Outlet />
    </Title>
  );
}
